/**
 * Добавляет ноль в начале числа от 0 до 9
 *
 * @param  {string | number} num
 * @returns string
 */
export function withLeadingZero(num: number, targetLength = 2) {
    return num.toString().padStart(targetLength, '0');
}
